<template>
  <add-address/>
</template>

<script>
import addAddress from '../../../components/user-profile/add-address-invoice'
export default {
  name: 'AddAddressInvoiceView',
  components: {
    addAddress
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/user-profile/add-address-invoice.view.vue